<template>
	<div id="usuario-perfil">
		<ld-popup
			id="popup-perfil-usuario"
			:fullscreen="true"
			:active.sync="activePopup"
			:disabledBackgoundClose="true"
		>
			<div v-if="usuario" class="popup-perfil-container p-2">
				<div class="flex justify-between w-full p-2 pb-5">
					<div class="flex items-center">
						<div class="content-title mr-5">
							<h2 class="title">Perfil do usuário</h2>
						</div>
					</div>

					<ld-button
						icon-pack="feather"
						icon="icon-x"
						size="large"
						color="dark"
						type="flat"
						@click="activePopup = false"
					>
					</ld-button>
				</div>

				<vx-card class="p-5">
					<div class="flex flex-col justify-center items-center mb-16">
						<vs-avatar size="150px" class="foto-perfil mb-5" :src="usuario && usuario.fotoThumb ?  usuario.fotoThumb : ''"/>

						<div>
							<h2 class="perfil-nome text-center">{{ usuario.nome }}</h2>
							<h4 class="perfil-tipo text-center">
								{{
									usuario.isSuperUser ? "Super administrador" : ""
								}}
							</h4>
						</div>
					</div>

					<div class="dados-usuario flex flex-col">
						<h4 class="subtitle mt-10 mb-2 font-bold">Dados do usuário</h4>
						<h5 class="text-base font-normal mb-10">
							As informações de perfil não podem ser alteradas.
						</h5>

						<vs-input
							v-if="usuario.nome"
							class="w-full mb-4"
							label="Nome"
							v-model="usuario.nome"
							disabled
						></vs-input>

						<vs-input
							v-if="usuario.email"
							class="w-full mb-4"
							label="E-mail"
							v-model="usuario.email"
							disabled
						></vs-input>

						<vs-input
							v-if="usuario.cpf"
							class="w-full mb-4"
							label="CPF"
							v-mask="'###.###.###-##'"
							v-model="usuario.cpf"
							disabled
						></vs-input>

						<vs-input
							v-if="usuario.telefone"
							class="w-full mb-4"
							label="Telefone"
							v-mask="['(##) # ####-####', '(##) ####-####']"
							v-model="usuario.telefone"
							disabled
						></vs-input>

						<vs-input
							v-if="usuario.dataNascimento"
							class="w-full mb-4"
							label="Data de nascimento"
							v-model="usuario.dataNascimento"
							disabled
						></vs-input>
					</div>

					<div class="relative">
						<h4 class="subtitle my-10 font-bold">Perfis</h4>

						<ul class="list-perfis flex flex-col pr-2" v-if="usuario && usuario.colaboradores && usuario.colaboradores.length">
							<li
								class="perfil"
								v-for="(colaborador) in usuario.colaboradores"
								:key="colaborador.key"
							>
								<div class="perfil-content">
									<h6 class="text-xs font-normal">Empresa</h6>
									<p class="empresa-name">{{colaborador.empresa.nome}}</p>
								</div>
								<div class="perfil-content">
									<h6 class="text-xs font-normal">Perfil</h6>
									<p class="perfil-name">{{colaborador.perfil}}</p>
								</div>
							</li>
						</ul>
					</div>
				</vx-card>

				<vx-card class="mt-8">
					<div class="relative p-5">
						<h4 class="subtitle mb-10 font-bold">Mudar senha</h4>

						<form id="form-mudar-senha" class="mb-3">
							<vs-input
								type="password"
								label="Senha atual"
								v-model="senhaAtual"
								name="senha_atual"
								class="w-full mb-6"
							/>

							<vs-input
								type="password"
								label="Nova senha"
								v-model="novaSenha"
								name="nova_senha"
								class="w-full mb-6"
							/>

							<vs-input
								type="password"
								label="Repita a nova senha"
								name="confirmar_senha"
								v-model="confirmarNovaSenha"
								class="w-full mb-8"
							/>

							<div class="flex flex-col-reverse md:flex-row flex-wrap justify-end">
								<ld-button
									color="dark"
									type="flat"
									class="md:mr-4 md:w-auto md:mt-0 mt-2 w-full"
									@click="limparMudancaSenha"
								>
									Limpar
								</ld-button>
								<ld-button
									type="border"
									class="md:w-auto md:mt-0 mt-2 w-full"
									@click="mudarSenha"
								>
									Mudar senha
								</ld-button>
							</div>
						</form>
					</div>
				</vx-card>

				<div class="flex flex-col-reverse md:flex-row flex-wrap justify-end mt-24">
					<ld-button
						class="md:w-auto md:mt-0 mt-2 w-full"
						@click="activePopup = false"
					>
						Fechar
					</ld-button>
				</div>
			</div>
		</ld-popup>

		<ld-popup
				title="Mudança de senha"
				:active.sync="popupMudancaSenha"
				:button-close-hidden="true"
				:disabledBackgoundClose="true"
			>
				<p>
					Sua senha foi alterada com sucesso.
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<vs-button
							class="w-32"
							color="primary"
							type="filled"
							@click="popupMudancaSenha = false"
							>OK</vs-button
						>
					</div>
				</div>
			</ld-popup>
	</div>
</template>

<script>
import DAO from "../../../DAO/DAO";

import moment from "moment";
import Usuario from '../../../models/Usuario';
import ErrorHelper from '../../../helpers/ErrorHelper';

export default {
	name: "UsuarioPerfil",
	data() {
		return {
			usuario: null,
			senhaAtual: null,
			novaSenha: null,
			confirmarNovaSenha: null,
			fotoPadrao: require("../../../assets/images/user.png"),
			popupMudancaSenha: false,
		};
	},
	props: {
		active: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		activePopup: {
			set(value) {
				this.$emit("update:active", value);
			},
			get() {
				return this.active;
			}
		}
	},
	methods: {
		setUsuario() {
			const usuario = DAO.user.get();

			const dataNascimento = moment(usuario.dataNascimento);

			if (dataNascimento.isValid()) {
				usuario.dataNascimento = dataNascimento.format("DD/MM/YYYY");
			}

			this.usuario = usuario;
		},
		async mudarSenha() {
			const loadingMudarSenha = this.$vsloading({
				container: "#popup-perfil-usuario .vs-popup--content",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {

				Usuario.validarSenhas(this.senhaAtual, this.novaSenha, this.confirmarNovaSenha);

				await Usuario.mudarSenha(this.senhaAtual, this.novaSenha);

				this.limparMudancaSenha();
				this.popupMudancaSenha = true;

			} catch (error) {
				console.error(error);
				Usuario.validarObrigatoriedadeConfirmacaoSenha(error, this.senhaAtual, this.confirmarNovaSenha);
				Usuario.messageErrorMudarSenha(error);
				ErrorHelper.renderFormError("#form-mudar-senha", error);
			} finally {
				loadingMudarSenha.hide();
			}
		},
		limparMudancaSenha() {
			this.senhaAtual = null;
			this.novaSenha = null;
			this.confirmarNovaSenha = null;

			const form = document.querySelector("#form-mudar-senha");
			if (form) {
				ErrorHelper.cleanFormErrors(form);
			}
		}
	},
	watch: {
		active() {
			if (this.active) {
				this.setUsuario();
				this.limparMudancaSenha();
			}
		},
	}
};
</script>

<style lang="scss" src="./usuario_perfil.scss"></style>
